<template>
	<div>
		<v-row class="ma-0 pa-5 title-text" justify="space-between" align="center">
			<div v-if="claimId === 0">Create new claim</div>
			<div v-else>{{ claim_number }} - {{ description }}</div>
			<v-icon @click="onCloseClaims()">mdi-close</v-icon>
		</v-row>
		<div class="pa-5 whole-context">
			<v-alert v-if="error_msg.length !== 0" type="error">
				{{ error_msg }}
			</v-alert>
			<ProgressLinear v-if="loading" />
			<div v-if="!loading" class="px-6 py-3 inside-context">
				<v-row class="ma-0 mb-5" align="center">
					<v-btn v-if="claimId === 0 || (claimId !== 0 && !isDeleteClaim)" class="text-capitalize white--text mr-6" color="#00AAFD" depressed
						:disabled="isSaveDisabled" @click="onSaveClaims()">Save changes</v-btn>
					<v-btn v-if="claimId !== 0 && isDeleteClaim" class="text-capitalize white--text mr-6" color="error" depressed
						@click="onDeleteClaimDialog()">Delete claim</v-btn>
					<v-btn class="text-capitalize" color="#82899B" text @click="onCloseClaims()">Cancel</v-btn>
				</v-row>
				<v-row v-if="claimId !== 0 && isFinanceUsers" class="ma-0 mb-5">
					<v-btn depressed color="#00AAFD" class="text-capitalize white--text"
						:disabled="!isAbleStatus || claim_status === posted_status || isNoDetails || !isAblePost" @click="onPostGL(claimId)">
						<v-progress-circular v-if="post_loading" class="mr-1" :width="2" :size="16" :value="20" :color="`#FFFFFF`" indeterminate></v-progress-circular>
						<v-icon v-else color="white" class="mr-1">mdi-check</v-icon>	
						<span class="button-text">Post</span>
					</v-btn>
					<v-btn outlined color="#00AAFD" class="ml-2 text-capitalize"
						:disabled="!isAbleStatus || claim_status === posted_status || isNoDetails" @click="onOpenRejectDialog()">
						<v-progress-circular v-if="reject_loading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
						<v-icon v-else class="mr-1">mdi-close</v-icon>
						<span>Reject</span>
					</v-btn>
					<v-btn outlined color="#82899B" class="ml-2 text-capitalize"
						:disabled="!isAbleStatus || claim_status === posted_status || isNoDetails" @click="onOpenForwardDialog()">
						<v-progress-circular v-if="forward_loading" class="mr-1" :width="2" :size="16" :value="20" :color="`#82899B`" indeterminate></v-progress-circular>
						<span>Forward</span>
					</v-btn>
					<v-btn outlined color="#82899B" class="ml-2 text-capitalize" @click="onPrint(claimId)">
						<v-progress-circular v-if="print_loading" class="mr-1" :width="2" :size="16" :value="20" :color="`#82899B`" indeterminate></v-progress-circular>
						<span>Print</span>
					</v-btn>
					<v-btn outlined color="#82899B" class="ml-2 text-capitalize" :disabled="!isRecover" @click="onOpenRecoverDialog()">
						<v-progress-circular v-if="recover_loading" class="mr-1" :width="2" :size="16" :value="20" :color="`#82899B`" indeterminate></v-progress-circular>
						<span>Recover</span>
					</v-btn>
					<v-btn outlined color="#82899B" class="ml-2 text-capitalize" :disabled="!isAbleDelete || isNoDetails" @click="onOpenDeleteDialog()">
						<v-progress-circular v-if="delete_loading" class="mr-1" :width="2" :size="16" :value="20" :color="`#82899B`" indeterminate></v-progress-circular>
						<span>Delete</span>
					</v-btn>
				</v-row>
				<v-row class="ma-0">
					<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6"
						:class="$vuetify.breakpoint.smAndDown ? 'pa-0' : 'pl-0 pr-3 py-0'">
						<v-row class="ma-0">
							<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6"
								:class="$vuetify.breakpoint.xsOnly ? 'px-0 pb-0' : 'pl-0 pr-3 pt-0 pb-0'">
								<div class="mb-1 field-title-text">Claim date</div>
								<DatePicker :color="color" :lableText="''" :isOutlined="true" :isIcon="true"
									:disabled="!isAbleDatePicker" :dateInit="date_init"
									:suggestionText="'eg, 120322 or 12/3/2022'" @date="date = $event" />
							</v-col>
							<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6"
								:class="$vuetify.breakpoint.xsOnly ? 'px-0 pt-2 pb-4' : 'pl-3 pr-0 pt-0 pb-0'">
								<div class="mb-1 field-title-text">Period</div>
								<v-select v-model="period" :items="periodList" :color="color" item-text="period_desc"
									item-value="id" :item-color="color" outlined return-object hide-details dense
									background-color="#FAFAFA" :disabled="!isAblePeriod" />
							</v-col>
							<v-col cols="12" :class="$vuetify.breakpoint.smAndDown ? 'px-0 pt-0' : 'px-0 pt-0 pb-4'">
								<div class="mb-1 field-title-text">Claim description</div>
								<v-text-field v-model="description" :placeholder="isAbleStatus ? 'REQUIRED' :''"
									:color="color" :disabled="!isAbleDesc"
									:error="description.length === 0" background-color="#FAFAFA" outlined hide-details dense />
							</v-col>
						</v-row>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6"
						:class="$vuetify.breakpoint.smAndDown ? 'pa-0' : 'pl-3 pr-0 py-0'">
						<v-row class="ma-0">
							<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6"
								:class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'pl-0 pr-3 pt-0 pb-4'">
								<div class="mb-1 field-title-text">Employee</div>
								<v-select v-model="employee" :items="employee_list" :color="color" :error="!employee"
									:placeholder="!employee && isAbleStatus ? 'REQUIRED' : ''" item-text="name"
									item-value="id" :item-color="color" outlined return-object hide-details dense
									background-color="#FAFAFA" :disabled="!isAbleEmployee"
									@change="onChangeEmployee($event)" />
							</v-col>
							<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6"
								:class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'pl-3 pr-0 pt-0 pb-4'">
								<div class="mb-1 field-title-text">Approver</div>
								<v-select v-model="approver" :items="approver_list" :color="color" :error="!approver"
									:disabled="!isAbleStatus || !isAbleApproval"
									:placeholder="isAbleStatus && !isAvailableApproval ? 'REQUIRED' :''"
									item-text="name" item-value="id" :item-color="color" outlined
									background-color="#FAFAFA" return-object hide-details dense />
							</v-col>
							<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 3"
								:class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'pl-0 pr-3 pb-4'" :style="$vuetify.breakpoint.xsOnly ? '':'padding-top: 10px'">
								<div class="mb-1 field-title-text">Currency</div>
								<v-select v-model="currency" :items="currencies" :color="color" item-text="code" :disabled="!isAbleCurrency"
									:class="{ 'currency-required': !currency && isAbleStatus }"
									:style="!currency && isAbleStatus ? { '--currency-border-color': color } : null"
									item-value="id" :item-color="color" outlined return-object hide-details dense background-color="#FAFAFA" />
							</v-col>
							<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 3"
								:class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'pl-3 pr-3 pb-4'" :style="$vuetify.breakpoint.xsOnly ? '':'padding-top: 10px'">
								<div class="mb-1 field-title-text">Amount</div>
								<v-text-field :value="`${currency && currency.symbol ? currency.symbol:''} ${attachedTotals.amount}`"
									outlined disabled dense hide-details background-color="#FAFAFA" />
							</v-col>
							<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 3"
								:class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'pl-3 pr-3 pb-4'" :style="$vuetify.breakpoint.xsOnly ? '':'padding-top: 10px'">
								<div class="mb-1 field-title-text">GST</div>
								<v-text-field :value="`${currency && currency.symbol ? currency.symbol:''} ${attachedTotals.gst}`"
									outlined disabled dense hide-details background-color="#FAFAFA" />
							</v-col>
							<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 3"
								:class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'pl-3 pr-0 pb-4'" :style="$vuetify.breakpoint.xsOnly ? '':'padding-top: 10px'">
								<div class="mb-1 field-title-text">To Pay</div>
								<v-text-field :value="`${currency && currency.symbol ? currency.symbol:''} ${attachedTotals.toPay}`"
									outlined disabled dense hide-details background-color="#FAFAFA" />
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row class="ma-0 mt-3 attached-actions" align="center">
					<div class="attached-title">Attached Expenses</div>
					<div class="attached-action-buttons">
						<v-btn class="mr-4 text-capitalize" depressed background-color="#FAFAFA" max-height="36"
							:disabled="!isSelected || !isFinanceUsers || !isAbleStatus" @click="onSplit()">
							<v-icon :color="isSelected && isFinanceUsers && isAbleStatus ? 'rgba(25, 42, 62, 0.7)' : 'rgba(0, 0, 0, 0.26)'" left
								size="18">mdi-content-copy</v-icon>
							<span
								:style="isSelected && isFinanceUsers && isAbleStatus ? 'color:rgba(25, 42, 62, 0.7)' : 'color:rgba(0, 0, 0, 0.26)'">Split</span>
						</v-btn>
						<v-btn class="text-capitalize" depressed background-color="#FAFAFA" max-height="36"
							:disabled="!isSelected || !isAbleStatus" @click="onDelExpense()">
							<v-icon left size="20"
								:color="isSelected && isAbleStatus ? 'rgba(25, 42, 62, 0.7)' : 'rgba(0, 0, 0, 0.26)'">mdi-delete-outline</v-icon>
							<span
								:style="isSelected && isAbleStatus ? 'color:rgba(25, 42, 62, 0.7)' : 'color:rgba(0, 0, 0, 0.26)'">Delete</span>
						</v-btn>
					</div>
				</v-row>
				<div class="attached-table mt-4 mb-10">
					<v-simple-table>
						<template v-slot:default>
							<thead>
								<tr>
									<th class="select-col">
										<v-checkbox class="attached-checkbox ma-0 pa-0"
											:input-value="allAttachedSelected" :indeterminate="attachedIndeterminate"
											color="info" hide-details dense :disabled="attachedExpenseRows.length === 0 || !isAbleStatus"
											@change="onSelectAllAttached($event)" />
									</th>
									<th class="text-start">
										<span class="attached-table-text">Date</span>
									</th>
									<th class="text-end">
										<span class="attached-table-text pr-2">Currency</span>
									</th>
									<th class="text-end">
										<span class="attached-table-text pr-2">Amount</span>
									</th>
									<th class="text-end">
										<span class="attached-table-text pr-2">GST</span>
									</th>
									<th class="text-end">
										<span class="attached-table-text pr-2">To Pay</span>
									</th>
									<th class="text-end">
										<span class="attached-table-text pr-2">Markup</span>
									</th>
									<th class="text-end">
										<span class="attached-table-text pr-2">Value</span>
									</th>
									<th class="text-start">
										<div class="attached-table-text pl-2">Job</div>
										<div class="attached-table-text pl-2">Phase</div>
									</th>
									<th class="text-start">
										<span class="attached-table-text pl-2">Kind</span>
									</th>
									<th class="text-start">
										<span class="attached-table-text pl-2">Description</span>
									</th>
									<th class="text-center">
										<span class="attached-table-text">File</span>
									</th>
								</tr>
							</thead>
							<tbody>
								<tr class="add-expense-row" >
									<td class="px-1" colspan="12">
										<v-btn class="text-capitalize px-3" text color="#00AAFD"
											:disabled="!isAbleStatus"
											@click="onExpenseDialogOpen()" >
											<v-icon class="mr-2">mdi-plus</v-icon>
											<span>Add Expense</span>
										</v-btn>
									</td>
								</tr>
								<tr v-for="(item, index) in attachedExpenseRows" :key="item.key"
									class="attached-expense-row" :class="{ 'split-expense-row': item.isSplit }"
									@click="onRowClick(index)">
									<td class="select-col">
										<v-checkbox class="attached-checkbox ma-0 pa-0" :input-value="item.select" :disabled="!isAbleStatus"
											color="info" hide-details dense @click.stop @change="onAttachedSelect(index, $event)" />
									</td>
									<td class="text-start">{{ item.date }}</td>
									<td class="text-end">
										<span class="pr-2" style="color: #4742C6">{{ item.currency }}</span>
									</td>
									<td class="text-end">
										<span class="amount-cell-value pr-2" :class="{ 'zero-amount-cell': item.isAmountZero }">
											{{ item.amount }}
										</span>
									</td>
									<td class="text-end">
										<span class="pr-2">{{ item.gst }}</span>
									</td>
									<td class="text-end">
										<span class="pr-2">{{ item.toPay }}</span>
									</td>
									<td class="text-end">
										<span>{{ item.markup }} %</span>
									</td>
									<td class="text-end">
										<span class="pr-2">{{ item.value }}</span>
									</td>
									<td class="text-start">
										<div class="pl-2">{{ item.job }}</div>
										<div class="pl-2">{{ item.phase }}</div>
									</td>
									<td class="text-start">
										<span class="pl-2">{{ item.kind }}</span>
									</td>
									<td class="text-start">
										<span class="pl-2">{{ item.description }}</span>
									</td>
									<td>
										<File
											v-if="item.fileType.length !== 0 && item.fileType !== 'application/pdf'"
											width="24"
											hight="24"
											:color="item.is_used ? '#DADADA' : 'rgba(25, 42, 62, 0.8)'"
										/>
										<PDF
											v-if="item.fileType.length !== 0 && item.fileType === 'application/pdf'"
											width="24"
											hight="24"
											:color="item.is_used ? '#DADADA' : 'rgba(25, 42, 62, 0.8)'"
										/>
									</td>
								</tr>
								<tr class="attached-total-row">
									<td></td>
									<td>Total</td>
									<td class="text-end">
										<span class="pr-2" style="color: #4742C6">{{ currency && currency.code }}</span>
									</td>
									<td class="text-end">
										<span class="pr-2">{{ attachedTotals.amount }}</span>
									</td>
									<td class="text-end">
										<span class="pr-2">{{ attachedTotals.gst }}</span>
									</td>
									<td class="text-end">
										<span class="pr-2">{{ attachedTotals.toPay }}</span>
									</td>
									<td class="text-end">
										<span class="pr-3">--</span>
									</td>
									<td class="text-end">
										<span class="pr-2">{{ attachedTotals.value }}</span>
									</td>
									<td colspan="4"></td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>
			</div>
		</div>
		<AttachedExpenseDialog
			v-if="expense_dialog_visible"
			:visible="expense_dialog_visible"
			:color="color"
			:currencies="currencies"
			:isShowMarkup="isShowMarkup"
			:isEditMarkup="isEditMarkup"
			:expense="existed_expense"
			:userId="user_id"
			@expense="onAddExpense($event)"
			@close="onExpenseDialogClose()"
		/>
		<NoticeConfirmDialog
			v-if="visible_notice"
			:visible="visible_notice"
			:text="notice_text"
			:color="notice_color"
			@ok="onClaimCreatedNoticeClose()"
		/>
		<DialogProgress
			v-if="split_loading"
			:visible="split_loading"
			:color="color"
			:note="`Spliting`"
		/>
		<DialogProgress 
			v-if="print_loading"
			:visible="print_loading" 
			:color="color"
		/>
		<ApprovalDialog 
			v-if="visible_reject"
			key="moreinfo_detail"
			:visible="visible_reject" 
			:color="color"
			:title_text="`More information required`"
			:suppliers="[employee]"
			@cancel="visible_reject = false"
			@ok="onReject($event)"
		/>
		<ApprovalDialog 
			v-if="visible_forward"
			key="forward_detail"
			:visible="visible_forward" 
			:color="color"
			:title_text="`Forward claim to...`"
			:isFinance="true"
			:confirm_button="`Submit`"
			@cancel="visible_forward = false"
			@submit="onForward($event)"
		/>
		<PrintClaims
			v-if="print_claims.length !== 0"  
			id="print"
			style="display: none"
			:printClaims="print_claims"
		/>
		<RecoverDialog
			v-if="visible_recover"
			:visible="visible_recover"
			:textColor="color"
			:titleText="'Recover deleted claim?'"
			:userName="employee.name"
			@cancel="visible_recover = false"
			@ok="onRecover($event)"
		/>
		<DeleteConfirmDialog
			v-if="visible_delete"
			:visible="visible_delete"
			:title="`You are about to delete claim`"
			:content="`This action cannot be undone. Are you sure?`"
			:okText="`Delete`"
			@cancel="visible_delete = false"
			@ok="onDelete()"
		/>
		<DeleteConfirmDialog
			v-if="visible_delete_claim"
			:visible="visible_delete_claim"
			:title="`You are about to delete claim`"
			:content="`This action cannot be undone. Are you sure?`"
			:okText="`Delete`"
			@cancel="visible_delete_claim = false"
			@ok="onDeleteClaim()"
		/>
	</div>
</template>

<script>
import ProgressLinear from "@/components/progress/progress_double_linear.vue";
import DatePicker from "@/components/date/date_picker.vue";
import PrintClaims from '@/components/expenses/print_claims';
import AttachedExpenseDialog from "@/views/desktop/webexpense/webexpense_expense.vue";
import NoticeConfirmDialog from "@/components/dialogs/notice_confirm_dialog.vue";
import ApprovalDialog from "@/views/expenses/approvals/approval_dialog.vue";
import RecoverDialog from "@/views/expenses/commond/recover_dialog.vue";
import DeleteConfirmDialog from "@/views/expenses/commond/delete_confirm_dialog.vue";
import DialogProgress from "@/components/dialogs/progress_dialog.vue";
import File from '@/components/icons/attached_file_image';
import PDF from '@/components/icons/attached_file_pdf';
import moment from 'moment';
import config from "@/config.js";

import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf';
import pdfjsworker from 'pdfjs-dist/es5/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsworker;

/**
 * 0=Other
 * 1=client
 * 2=Suppliers
 * 3=Employees
 * 6=Banks
 * 7=(Non)-performing artists
 * 8=Talent agencies
 * 9=Credit card suppliers
 * 10=Superannuation suppliers(Super fund)
 * 12=Freelancers
 * 14=Prospect
 * 15=Self billing talent
 * 16=Contacts
 * 17=Media suppliers
 * 18=Freelancer agencies
 */

/** Create and edit expense claims */
const SEC = 'Sec';
/** Access other users expense claims */
const SEOTH = 'Seoth';
/** Edit expense claim privilege */
const EECP = 'Secapa';
/** Modify approval by field of expense claims */
const SCEAB = 'Sceab';

/** If ticked the user can see markups configured in the system */
const MUVW = 'MUvw';
/** If ticked the user can modify markups configured in the system */
const MUAM = 'MUam';

const CLAIM_STATUSES = config.claim_statuses;
const MAX_WIDTH = 600;

const SCALE = 1.2;
const PAGE_INIT = 0;

export default {
	name: 'WebExpenseClaim',
	props: {
		color: {
			type: String,
			default: '#FFB946'
		},
		claimId: {
			type: Number,
			default: 0
		}
	},
	data() {
		this.draft = CLAIM_STATUSES.draft.value;
		this.submitted = CLAIM_STATUSES.pending.value;
		this.approved = CLAIM_STATUSES.approved.value;
		this.rejected = CLAIM_STATUSES.rejected.value;
		this.posted_status = CLAIM_STATUSES.posted.value;
		this.deleted = CLAIM_STATUSES.deleted.value;
		this.paid = CLAIM_STATUSES.paid.value;

		return {
			loading: false,
			split_loading: false,
			privileges: [],
			user_adb_id: 0,
			user_id: 0,
			error_msg: '',
			visible_notice: false,
			notice_text: [],
			notice_color: '#00AAFD',
			
			date_init: moment().format('YYYY-MM-DD'),
			date: moment().format('YYYY-MM-DD'),

			period: null,
			period_options: [],
			entry_period: null,

			description: '',
			currencies: [],
			currency: null,
			employee_list: [],
			employee: null,
			approver_list: [],
			approver: null,
			
			amount_sum: '0.00',
			gst_sum: '0.00',
			to_pay_sum: '0.00',
			value_sum: '0.00',
			totals_calculation_id: 0,

			expense_dialog_visible: false,
			details: [],
			existed_expense: null,

			claim_number: '',
			claim_status: 0,
			claim_submitted_date: '',
			claim_has_payment: false,
			claim_no_details: false,

			post_loading: false,
			reject_loading: false,
			forward_loading: false,
			print_loading: false,
			recover_loading: false,
			delete_loading: false,
			visible_reject: false,
			visible_forward: false,
			visible_delete: false,
			visible_recover: false,
			visible_delete_claim: false,
			image_arr: [],
			print_claims: []
		}
	},
	components: {
		ProgressLinear,
		DatePicker,
		PrintClaims,
		AttachedExpenseDialog,
		NoticeConfirmDialog,
		ApprovalDialog,
		RecoverDialog,
		DeleteConfirmDialog,
		DialogProgress,
		File,
		PDF
	},
	async created() {
		await this.initPrivileges();
		await this.getCurrencies();
		if (this.claimId !== 0) {
			await this.getClaim(this.claimId);

			if (this.isFinanceUsers) {
				await Promise.all([this.getPeriodList(), this.getEntryPeriod()]);
			}
		}
		await this.getCurrentUserAdbId();
		

		if (this.claimId === 0) {
			this.getCreatePeriods();
		}
		this.getEmployee();
		this.getApproverEmployees();
	},
	watch: {
		details: {
			deep: true,
			handler() {
				this.calculateAttachedTotals();
			}
		},
		currency() {
			this.calculateAttachedTotals();
		},
		date() {
			this.calculateAttachedTotals();
		}
	},
	computed: {
		isAbleDatePicker() {
			let is_able_date_picker = false;

			if (this.privileges.length !== 0) {
				if (this.claimId === 0) {
					is_able_date_picker = this.privileges.includes(SEC) ? true : false;
				} else {
					const claim_number = this.claim_number || '';
					const un_able_status = this.claim_has_payment
						|| this.claim_status === this.deleted
						|| claim_number.includes('-r')
						|| claim_number.includes('*r');
						
					if (this.isFinanceUsers) {
						is_able_date_picker = un_able_status ? false : true;
					} else {
						const approve_status = this.claim_status === this.approved;
						const posted_status = this.claim_status === this.posted_status;
						is_able_date_picker = this.privileges.includes(SEC) && !un_able_status && !approve_status && !posted_status ? true : false;
					}
				}
			}

			return is_able_date_picker;
		},
		isAblePeriod() {
			/** editing a claim, to check Period field is able to edit or not */
			let is_edit_period = false;

			if (this.privileges.length !== 0) {
				if (this.claimId !== 0) {
					if (this.isFinanceUsers) {
						const claim_number = this.claim_number || '';
						const un_able_status = this.claim_has_payment
							|| this.claim_status === this.deleted
							|| claim_number.includes('-r')
							|| claim_number.includes('*r');

						is_edit_period = un_able_status ? false : true;
					}
				}
			}

			return is_edit_period;
		},
		isAbleDesc() {
			let is_able_desc = false;

			if (this.privileges.length !== 0) {
				if (this.claimId === 0) {
					is_able_desc = this.privileges.includes(SEC) ? true : false;
				} else {
					const claim_number = this.claim_number || '';
					const un_able_status = this.claim_has_payment
						|| this.claim_status === this.deleted
						|| claim_number.includes('-r')
						|| claim_number.includes('*r');

					if (this.isFinanceUsers) {
						is_able_desc = un_able_status ? false : true;
					} else {
						const approve_status = this.claim_status === this.approved;
						const posted_status = this.claim_status === this.posted_status;

						is_able_desc = this.privileges.includes(SEC) && !un_able_status && !approve_status && !posted_status ? true : false;
					}
				}
			}

			return is_able_desc;
		},
		isAbleEmployee() {
			let is_abled_employee = false;

			if (this.privileges.length !== 0) {
				if (this.claimId === 0) {
					is_abled_employee = this.privileges.includes(SEC) && this.privileges.includes(SEOTH) ? true : false;
				} else {
					is_abled_employee = false;
				}
			}

			return is_abled_employee;
		},
		isAbleApproval() {
			let is_abled_approval = false;

			if (this.privileges.length !== 0) {
				if (this.claimId === 0) {
					is_abled_approval = this.privileges.includes(SEC) ? true : false;
				} else {
					if (this.isFinanceUsers) {
						is_abled_approval = false;
					} else {
						const claim_number = this.claim_number || '';
						const un_able_status = this.claim_has_payment
							|| this.claim_status === this.deleted
							|| claim_number.includes('-r')
							|| claim_number.includes('*r');
							
						const approve_status = this.claim_status === this.approved;
						const posted_status = this.claim_status === this.posted_status;

						is_abled_approval = this.privileges.includes(SCEAB) && !un_able_status && !approve_status && !posted_status ? true : false;
					}
				}
			}

			return is_abled_approval
		},
		isAbleCurrency() {
			let is_able_currency = false;

			if (this.privileges.length !== 0) {
				if (this.claimId === 0) {
					is_able_currency = this.privileges.includes(SEC) ? true : false;
				} else {
					const claim_number = this.claim_number || '';
					const un_able_status = this.claim_has_payment
						|| this.claim_status === this.deleted
						|| claim_number.includes('-r')
						|| claim_number.includes('*r');

					if (this.isFinanceUsers) {
						is_able_currency = un_able_status ? false : true;
					} else {
						const approve_status = this.claim_status === this.approved;
						const posted_status = this.claim_status === this.posted_status;

						is_able_currency = this.privileges.includes(SEC) && !un_able_status && !approve_status && !posted_status ? true : false;
					}
				}
			}

			return is_able_currency;
		},
		isAvailableApproval() {
			let is_available_approval = false;

			if (this.claimId !== 0 && this.approver && this.approver_list.findIndex(a => {return a.id === this.approver.id }) !== -1) {
				is_available_approval = true;
			}

			return is_available_approval;
		},
		isAbleStatus() {
			/** editing a claim, to check the current claim is able to edit or not */
			let is_able_status = true;

			if (this.privileges.length !== 0) {
				if (this.claimId === 0) {
					is_able_status = this.privileges.includes(SEC) ? true : false;
				} else {
					const claim_number = this.claim_number || '';
					const unable_status = this.claim_has_payment
						|| this.claim_status === this.deleted
						|| claim_number.includes('-r')
						|| claim_number.includes('*r');
					if (this.isFinanceUsers) {
						const availabe_status = [this.draft, this.submitted, this.rejected].includes(this.claim_status);
						if (!availabe_status) {
							is_able_status = unable_status ? false : true;
						}
					} else {
						const approve_status = this.claim_status === this.approved;
						const posted_status = this.claim_status === this.posted_status;
						
						is_able_status = this.privileges.includes(SEC) && !unable_status && !approve_status && !posted_status ? true : false;
					}
				}
			}

			return is_able_status;
		},
		isNoDetails() {
			let is_no_claim = false;

			if (this.details.length === 0) {
				is_no_claim = true;
			}

			return is_no_claim;
		},
		isRecover() {
			let is_recover = false;

			if (this.isFinanceUsers) {
				const claim_number = this.claim_number || '';
				const unable_status = this.claim_has_payment
					|| this.claim_status === this.posted_status
					|| claim_number.includes('-r')
					|| claim_number.includes('*r');

				is_recover = !unable_status && this.claim_status === this.deleted ? true : false;
			}

			return is_recover;
		},
		isAbleDelete() {
			let is_able_delete = false;

			if (this.isFinanceUsers) {
				const availabe_status = [this.draft, this.submitted, this.approved, this.rejected].includes(this.claim_status);
				is_able_delete = availabe_status ? true : false;
			}

			return is_able_delete;
		},
		isFinanceUsers() {
			let is_finance_user = false;

			if (this.privileges.length !== 0) {
				is_finance_user = this.privileges.includes(EECP) ? true : false;
			}

			return is_finance_user;
		},
		isSaveDisabled() {
			const has_description = typeof this.description === 'string'
				&& this.description.trim().length !== 0;
			const has_valid_details = this.details.every(detail => {
				return detail.date && detail.date.length !== 0
					&& detail.job !== null
					&& detail.phase !== null
					&& detail.kind !== null
					&& detail.currency !== null
					&& Number(detail.gross) !== 0;
			});
			const privilege_able = this.claimId === 0 
				? this.privileges.includes(SEC) 
				: (this.isFinanceUsers ? true : this.privileges.includes(SEC));

			return !this.approver
				|| !has_description
				|| this.details.length === 0
				|| !has_valid_details
				|| !this.isAbleStatus
				|| !privilege_able; 
		},
		isAblePost() {
			return this.details.every(detail => {return Number(detail.gross) !== 0 });
		},
		isDeleteClaim() {
			let is_delete_claim = false;

			if (!this.claim_no_details && this.details.length === 0) {
				is_delete_claim = true;
			}

			return is_delete_claim;
		},
		isSelected() {
			return this.details.some(detail => detail.select === true);
		},
		isShowMarkup() {
			let is_show_markup = false;

			if (this.privileges.length !== 0) {
				is_show_markup = this.privileges.includes(MUVW) ? true : false;
			}

			return is_show_markup;
		},
		isEditMarkup() {
			let is_edit_markup = false;

			if (this.privileges.length !== 0) {
				is_edit_markup = this.privileges.includes(MUAM) ? true : false;
			}

			return is_edit_markup;
		},
		periodList() {
			let period_list = [];

			if (this.claimId === 0 || (this.claimId !== 0 && !this.isFinanceUsers)) {
				period_list =  this.period ? [this.period] : [];
			}

			if (this.claimId !== 0 && this.isFinanceUsers && this.period_options.length !== 0 && this.entry_period) {
				period_list = [
					this.period_options[0],
					this.entry_period,
					...this.period_options.slice(1)
				];
			}

			return period_list;
		},
		attachedExpenseRows() {
			return this.details.map(detail => {
				return {
					key: detail.index,
					isSplit: detail.is_new_split === true,
					select: detail.select === true,
					date: detail.date ? moment(detail.date).format('DD MMM YYYY') : '',
					currency: (detail.currency && detail.currency.code) || '',
					amount: this.formatNumber(this.getNumber(detail.gross)),
					isAmountZero: Number(detail.gross) === 0,
					gst: this.formatNumber(this.getNumber(detail.tax_amount)),
					toPay: this.formatNumber(this.getNumber(detail.amount)),
					markup: this.formatNumber(detail.markup),
					value: this.formatNumber(this.getNumber(detail.value_fc)),
					job: (detail.job && (detail.job.display_name || detail.job.code)) || '',
					phase: (detail.phase && detail.phase.display_name) || '',
					kind: (detail.kind && detail.kind.display_name) || '',
					description: detail.description || '',
					file: detail.file_blob,
					fileType: detail.file_type || ''
				};
			});
		},
		allAttachedSelected() {
			return this.details.length !== 0 && this.details.every(detail => detail.select === true);
		},
		attachedIndeterminate() {
			return this.details.some(detail => detail.select === true) && !this.allAttachedSelected;
		},
		attachedTotals() {
			return {
				amount: this.amount_sum,
				gst: this.gst_sum,
				toPay: this.to_pay_sum,
				value: this.value_sum
			};
		}
	},
	methods: {
		async initPrivileges() {
			this.loading = true;

			const url = "/api/user/me/privileges";

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, data } = val.data;

					if (status === "OK") {
						this.privileges = data.filter(p => { return p.startsWith('S') || p.startsWith('M') });
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		async getCurrencies() {
			this.loading = true;

			const url = `/api/config/country`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const currencies_by_id = new Map();

							data.forEach(country => {
								if (!country.currency) return;

								const { currency, ...country_details } = country;
								if (!currencies_by_id.has(currency.id)) {
									currencies_by_id.set(currency.id, Object.assign({}, currency, {
										countries: []
									}));
								}

								currencies_by_id.get(currency.id).countries.push(country_details);
							});

							this.currencies = Array.from(currencies_by_id.values());
						}
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		async getClaim(id) {
			this.loading = true;

			const url = `/api/expenses/claims/${id}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, data, reason } = val.data;
					if (status == "OK") {
						this.claim_number = data.number;
						this.claim_status = data.status;
						this.claim_has_payment = data.has_payment;
						this.claim_submitted_date = data.submitted_date;

						this.date_init = moment(data.date).format('YYYY-MM-DD');
						this.date = moment(data.date).format('YYYY-MM-DD');

						this.period = data.period;
						this.description = data.description;
						this.currency = data.currency;

						data.supplier['name'] = this.formatName(data.supplier.display_name);
						this.employee = data.supplier;
						this.employee_list = [data.supplier];

						data.approval_by['name'] = this.formatName(data.approval_by.display_name);
						this.approver = data.approval_by;
						this.approver_list = [data.approval_by];

						this.claim_no_details = data.details && data.details.length === 0 ? true : false;

						this.details = data.details.map((detail, index) => {
							const receipt = detail.receipt || {};
							const tax_setting = config.tax_settings.find(setting => {
								return setting.value === receipt.taxmode;
							}) || null;

							return {
								receipt_id: receipt.id || 0,
								index: index,
								date: receipt.date,
								currency: receipt.currency,
								amount: Number(receipt.gross) + Number(receipt.tax_amount),
								description: detail.description || '',
								phase: detail.phase || null,
								job: detail.job || null,
								kind: detail.kind || null,
								gross: Number(receipt.gross),
								tax_mode: receipt.taxmode,
								tax_setting: tax_setting,
								tax_amount: Number(receipt.tax_amount),
								tax_perc: Number(receipt.tax_perc),
								markup: Number(receipt.markup),
								value_fc: Number(receipt.value),
								file_type: receipt.image_type || '',
								file_blob: null,
								select: false,
								receipt_employee: data.supplier,
								receipt_image: receipt.image || '',
								receipt_thumbnail: receipt.thumbnail || '',
								once_paid: data.once_paid === true
							};
						});
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					if (this.loading) {
						this.loading = false;
					}
				});
		},
		async getCurrentUserAdbId() {
			const url = '/api/user/me';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.user_adb_id = data.addressbook ? data.addressbook.id : 0;
						this.user_id = data.id;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getCreatePeriods() {
			const period_obj = {
				id: 0,
				period_desc: moment().format('MMMM YYYY')
			};
			this.period = period_obj;
		},
		getPeriodList() {
			const params = [];
			params.push('include_current=' + true);
			params.push('include_future=' + true);
			params.push('include_past=' + false);
			if (this.period) {
				params.push('periods=' + `${this.period.id}`);
			}

			let url = "/api/config/periods";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}
			return axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						const options_current_tmp = data.filter(d => { return d.is_current === true });
						options_current_tmp.forEach(o => {o.period_desc = `Current period - ${o.period_desc}`});

						const options_tmp = data.filter(d => { return d.is_current === false });
						options_tmp.sort((a,b) => {return a.id - b.id});

						this.period_options = [...options_current_tmp, ...options_tmp];
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		getEntryPeriod() {
			let url = "/api/config/periods/entry_period";

			return axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						data.period_desc = `Entry period - ${data.period_desc}`;
						this.entry_period = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		getEmployee() {
			let url = '/api/addressbook';

			const params = [];
			// 3 = "Employees", from 'api/addressbook/meta'
			params.push("abook_types=" + encodeURIComponent("3"));

			if (params.length > 0) {
				url += "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status === "OK") {
						data.forEach(d => {
							d['name'] = this.formatName(d.display_name);
						});
						this.employee_list = data;

						if (this.claimId === 0) {
							if (this.privileges.includes(SEOTH)) {
								this.employee = null;
							} else {
								const employee_current_arr = data.filter(d => { return d.id === this.user_adb_id });
								this.employee = employee_current_arr[0];

								if (this.employee) {
									/** init currency by employee */
									if (this.employee && this.employee.currency) {
										this.currency = this.currencies.find(c => { return c.id === this.employee.currency.id });
									}
								}
							}
						} else {
							if (this.employee && !data.some(employee => { return employee.id === this.employee.id })) {
								this.employee_list.push(this.employee);
							}
						} 
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				});
		},
		onChangeEmployee(employee) {
			this.employee = employee;

			if (this.employee) {
				/** init currency by employee */
				if (this.employee && this.employee.currency) {
					this.currency = this.currencies.find(c => { return c.id === this.employee.currency.id });
				}
			}
		},
		getApproverEmployees() {
			const url = "/api/addressbook?abook_types=3&has_privilege=Secap"

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status === "OK") {
						data.forEach(d => {
							d['name'] = this.formatName(d.display_name);
						});
						this.approver_list = data;
						if (this.claimId !== 0 && this.approver) {
							if (data.findIndex(d => { return d.id === this.approver.id }) === -1) {
								this.approver_list.push(this.approver);
							}
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				});
		},
		onAttachedSelect(index, value) {
			this.$set(this.details[index], 'select', value);
		},
		onSelectAllAttached(value) {
			this.details.forEach((detail, index) => {
				this.$set(this.details[index], 'select', value);
			});
		},
		onExpenseDialogOpen() {
			this.existed_expense = null;
			this.expense_dialog_visible = true;
		},
		onRowClick(index) {
			if (!this.isAbleStatus) return;
			
			this.existed_expense = this.details[index];
			this.expense_dialog_visible = true;
		},
		onExpenseDialogClose() {
			this.expense_dialog_visible = false;
			this.existed_expense = null;
		},
		async onSplit() {
			this.split_loading = true;
			const details_copy_all = [];
			let copy_index = 0;

			try {
				for (let detail_index = 0; detail_index < this.details.length; detail_index += 1) {
					const detail = this.details[detail_index];
					const original_detail = Object.assign({}, detail, { index: copy_index, select: false });

					details_copy_all.push(original_detail);
					copy_index += 1;

					if (detail.select === true) {
						const copy_detail = Object.assign({}, detail, {
							index: copy_index,
							gross: 0,
							tax_mode: detail.tax_mode,
							tax_setting: config.tax_settings.find(setting => setting.value === detail.tax_mode),
							tax_amount: 0,
							tax_perc: detail.tax_perc,
							amount: 0,
							value_fc: 0,
							file_blob: null,
							file_type: '',
							receipt_image: '',
							receipt_thumbnail: '',
							is_new_split: true,
							select: false
						});
						const receipt_blob = new Blob([''], { type: 'image/jpeg' });
						const new_receipt = await this._newReceipt(receipt_blob);

						if (!new_receipt) {
							continue;
						}

						copy_detail.receipt_id = new_receipt.id;
						copy_detail.receipt_employee = new_receipt.employee;

						const updated = await this._updateReceipt(new_receipt.id, copy_detail, new_receipt.employee);
						if (!updated) {
							await this._deleteReceipt(new_receipt.id);
							continue;
						}

						details_copy_all.push(copy_detail);
						copy_index += 1;
					}
				}

				this.details = details_copy_all;
			} finally {
				this.split_loading = false;
			}
		},
		async onDelExpense() {
			if (this.claimId !== 0) {
				this.details = this.details.filter(detail => detail.select !== true);
			} else {
				const selected_details = this.details.filter(detail => detail.select === true);
				const deleted_details = [];

				for (let index = 0; index < selected_details.length; index += 1) {
					const detail = selected_details[index];
					const deleted = await this._deleteReceipt(detail.receipt_id);

					if (deleted) {
						deleted_details.push(detail);
					}
				}

				this.details = this.details
					.filter(detail => !deleted_details.includes(detail))
					.map((detail, index) => {
						return Object.assign({}, detail, { index: index });
					});
			}
		},
		onAddExpense(expense) {
			if (!expense) {
				return;
			}

			const expense_position = this.details.findIndex(detail => {
				if (expense.index !== null && expense.index !== undefined) {
					return detail.index === expense.index;
				}

				return Object.keys(expense)
					.filter(key => key !== 'index')
					.every(key => detail[key] === expense[key]);
			});

			if (expense_position >= 0) {
				const current_index = this.details[expense_position].index;
				const is_new_split = this.details[expense_position].is_new_split === true;
				const replacement = Object.assign({}, expense, {
					index: current_index,
					is_new_split: is_new_split
				});

				this.$set(this.details, expense_position, replacement);
			} else {
				const last_detail = this.details[this.details.length - 1];
				const last_index = last_detail ? Number(last_detail.index) : -1;

				expense.index = Number.isFinite(last_index)
					? last_index + 1
					: this.details.length;

				this.details.push(expense);
			}

			this.expense_dialog_visible = false;
			this.existed_expense = null;
		},
		formatName(name) {
			let display_name = '';

			if (name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index - 1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
		formatNumber(num) {
			let res = 0;
			if (num === null || num === undefined || num === '') {
				return '0.00';
			}
			if (Number.isInteger(num)) {
				const integer = num.toLocaleString();
				res = integer + '.00';
			} else {
				const num_arr = (num.toString()).split('.');
				const integer = Number(num_arr[0]).toLocaleString();

				if (num_arr.length > 1) {
					if (num_arr[1].length === 1) {
						res = integer + '.' + num_arr[1] + '0';
					} else {
						res = integer + '.' + num_arr[1];
					}

				} else {
					res = integer + '.00';
				}
			}
			return res;
		},
		getNumber(...values) {
			const value = values.find(v => v !== null && v !== undefined && v !== '');
			const number = Number(value);

			return Number.isNaN(number) ? 0 : Number(Number(number).toFixed(2)) ;
		},
		async calculateAttachedTotals() {
			const calculation_id = this.totals_calculation_id + 1;
			this.totals_calculation_id = calculation_id;

			const totals = {
				amount: 0,
				gst: 0,
				to_pay: 0,
				value: 0
			};
			const rate_cache = {};
			const get_rate = (currency_id, date) => {
				const key = `${currency_id}_${date}`;

				if (!rate_cache[key]) {
					rate_cache[key] = this._get_exchange_rate(currency_id, date);
				}

				return rate_cache[key];
			};

			for (let index = 0; index < this.details.length; index += 1) {
				const detail = this.details[index];
				let exchange_multiplier = 1;

				if (this.currency && detail.currency && detail.currency.id !== this.currency.id) {
					const claim_rate = Number(await get_rate(this.currency.id, this.date));
					const receipt_rate = Number(detail.currency.exrate)
						|| Number(await get_rate(detail.currency.id, detail.date));

					if (claim_rate <= 0 || receipt_rate <= 0) {
						return;
					}

					exchange_multiplier = claim_rate / receipt_rate;
				}

				totals.amount += Number((this.getNumber(detail.gross) * exchange_multiplier).toFixed(2));
				totals.gst += Number((this.getNumber(detail.tax_amount) * exchange_multiplier).toFixed(2));
				totals.to_pay += Number((this.getNumber(detail.amount) * exchange_multiplier).toFixed(2));
				totals.value += Number((this.getNumber(detail.value_fc) * exchange_multiplier).toFixed(2));
			}

			if (calculation_id !== this.totals_calculation_id) {
				return;
			}

			this.amount_sum = this.formatNumber(Number(totals.amount.toFixed(2)));
			this.gst_sum = this.formatNumber(Number(totals.gst.toFixed(2)));
			this.to_pay_sum = this.formatNumber(Number(totals.to_pay.toFixed(2)));
			this.value_sum = this.formatNumber(Number(totals.value.toFixed(2)));
		},
		onPostGL(claim_id) {
			if (this.post_loading) return;
			
			if (this.isAbleStatus && this.claim_status !== this.posted_status) {
				this._post_gl(claim_id);
			}
		},
		onOpenRejectDialog() {
			if (this.reject_loading) return;

			this.visible_reject = true;
		},
		async onReject(reason) {
			this.reject_loading = true;

			const claim_params = await this.getParams(this.rejected, this.period.id);

			const reason_with_date = `${reason}${config.remark_date_flag}${moment().format('YYYY-MM-DD')}`;
			claim_params['remark'] = reason_with_date;

			const url = `/api/expenses/claims/${this.claimId}`;

			axios
				.put(url, claim_params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						if (this.visible_reject) {
							this.visible_reject = false;
						}
						this.reject_loading = false;

						this.notice_text = ['Claim rejected successfully.'];
						this.visible_notice = true;
					} else {
						if (this.visible_reject) {
							this.visible_reject = false;
						}
						this.reject_loading = false;
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					if (this.visible_reject) {
						this.visible_reject = false;
					}
					this.reject_loading = false;
					this.error_msg = e.message;
				});
		},
		onOpenForwardDialog() {
			if (this.forward_loading) return;

			this.visible_forward = true;
		},
		async onForward(event) {
			this.forward_loading = true;

			const send_email = event.approval_by.id !== this.approver.id;
			const claim_params = await this.getParams(this.claim_status, this.period.id, null, send_email);
			claim_params['approval_by'] = event.approval_by.id;
			claim_params['remark'] = event.reason;

			const url = `/api/expenses/claims/${this.claimId}`;

			axios
				.put(url, claim_params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						if (this.visible_forward) {
							this.visible_forward = false;
						}
						this.forward_loading = false;

						this.notice_text = ['Claim forwarded successfully.'];
						this.visible_notice = true;
					} else {
						if (this.visible_forward) {
							this.visible_forward = false;
						}
						this.forward_loading = false;
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					if (this.visible_forward) {
						this.visible_forward = false;
					}
					this.forward_loading = false;
					this.error_msg = e.message;
				});
		},
		async onPrint(claim_id) {
			if (this.print_loading) return;

			this.print_loading = true;
			this.print_claims = [];
			const receipt_with_image  = this.details.filter(d => { return d.receipt_image && d.receipt_image.length !== 0 });

			const image_blob_arr = [];
			for (let index = 0; index < receipt_with_image.length; index++) {
				const detail = receipt_with_image[index];
				const url = `${detail.receipt_image}`;
				await axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						},
						responseType: 'blob',
					})
					.then((val) => {
						const { status, data } = val;
						if (status === 200) {
							const data_obj = {
								id: claim_id,
								data: data
							};
							image_blob_arr.push(data_obj);
						}
					})
					.catch((e) => {
						this.$emit('error-msg', e.message);
					});
			}

			if (image_blob_arr.length === 0) {
				this.setPrintItem();
			} else {
				this.getImageList(image_blob_arr);
			}
		},
		onOpenRecoverDialog() {
			if (this.recover_loading) return;

			this.visible_recover = true;
		},
		onRecover(msg) {
			this.recover_loading = true;
			const url = `/api/expenses/claims/${this.claimId}/reactivate?remark=${msg}`;

			axios
				.post(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						if (this.visible_recover) {
							this.visible_recover = false;
						}
						this.recover_loading = false;
						
						this.notice_text = ['Claim recovered successfully.'];
						this.visible_notice = true;
						
					} else {
						if (this.visible_recover) {
							this.visible_recover = false;
						}
						this.recover_loading = false;
						this.error_msg = reason;
					}
				})
				.catch(e => {
					if (this.visible_recover) {
						this.visible_recover = false;
					}
					this.recover_loading = false;
					this.error_msg = e.message;
				});
		},
		onOpenDeleteDialog() {
			if (this.delete_loading) return;

			if (this.isAbleDelete) {
				this.visible_delete = true;
			}
		},
		onDelete() {
			this.delete_loading = true;

			const url = `/api/expenses/claims/${this.claimId}`;

			axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						if (this.visible_delete) {
							this.visible_delete = false;
						}
						this.delete_loading = false;
						
						this.notice_text = ['Your claim has been deleted successfully.'];
						this.visible_notice = true;
					} else {
						if (this.visible_delete) {
							this.visible_delete = false;
						}
						this.delete_loading = false;
						this.error_msg = reason;
					}
				})
				.catch(e => {
					if (this.visible_delete) {
						this.visible_delete = false;
					}
					this.delete_loading = false;
					this.error_msg = e.message;
				});
		},
		async onDeleteClaim() {
			this.visible_delete_claim = false;
			const claim_params = await this.getParams(this.claim_status, this.period.id);

			const url = `/api/expenses/claims/${this.claimId}`;

			axios
				.put(url, claim_params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.onDelete();
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		onSaveClaims() {
			if (this.claimId === 0) {
				this.onCreateClaim();
			}

			if (this.claimId !== 0) {
				this.onUpdateClaim();
			}
		},
		onDeleteClaimDialog() {
			if (this.claimId === 0) return;

			this.visible_delete_claim = true;
		},
		async onCreateClaim() {
			const claim_params = await this.getParams(this.draft);

			const url = "/api/expenses/claims";

			axios
				.post(url, claim_params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(async (val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const period_id = data.period ? data.period.id : 0;
						const submitted_claim_params = await this.getParams(this.submitted, period_id, null, true);
						const update_url = `/api/expenses/claims/${data.id}`;

						return axios
							.put(update_url, submitted_claim_params, {
								headers: {
									"Authorization": "Bearer " + this.$store.state.token,
									"Accept": "application/json"
								}
							})
							.then((update_val) => {
								const { status: update_status, reason: update_reason } = update_val.data;

								if (update_status == "OK") {
									this.notice_text = ['Your claim has been created successfully.'];
									this.visible_notice = true;
								} else {
									this.error_msg = update_reason;
								}
							});
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async onUpdateClaim() {
			const status = this.claim_status === this.rejected ? this.submitted : this.claim_status; 
			const claim_params = await this.getParams(status, this.period.id);

			const url = `/api/expenses/claims/${this.claimId}`;

			axios
				.put(url, claim_params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.notice_text = ['Your claim has been updated successfully.'];
						this.visible_notice = true;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		onClaimCreatedNoticeClose() {
			this.visible_notice = false;
			this.notice_text = [];
			this.details = [];
			this.$emit('close');
		},
		async getParams(status, period_id=0, claim_details=null, send_email=false) {
			const details = [];
			const source_details = claim_details || this.details;

			for (const detail of source_details) {
				let gross = Number(Number(detail.gross).toFixed(2));
				let tax_amount = Number(Number(detail.tax_amount).toFixed(2));
				let amount = Number(Number(detail.amount).toFixed(2));
				let value_fc = Number(Number(detail.value_fc).toFixed(2));

				if (detail.currency.id !== this.currency.id) {
					const rate = Number(await this._get_exchange_rate(this.currency.id, this.date));
					const origin_rate = Number(await this._get_exchange_rate(detail.currency.id, detail.date));

					gross = Number((rate * (gross / origin_rate)).toFixed(2));
					tax_amount = tax_amount === 0 ? 0 : Number((rate * (tax_amount / origin_rate)).toFixed(2));
					amount = amount === 0 ? 0 : Number((rate * (amount / origin_rate)).toFixed(2));
					value_fc = value_fc === 0 ? 0 : Number((rate * (value_fc / origin_rate)).toFixed(2));
				}
				const detail_obj = {
					receipt_id: detail.receipt_id,
					amount: amount,
					description: detail.description,
					gross: gross,
					tax_mode: detail.tax_mode,
					tax_perc: detail.tax_perc,
					tax_amount: tax_amount,
					markup: detail.markup,
					value_fc: value_fc
				};

				if (detail.phase) {
					detail_obj['phase_id'] = detail.phase.id;
				}
				if (detail.job) {
					detail_obj['job_id'] = detail.job.id;
				}
				if (detail.kind) {
					detail_obj['kind_id'] = detail.kind.id;
				}

				details.push(detail_obj);
			}

			const claim = {
				supplier_id: this.employee.id,
				date: this.date,
				desc: this.description.trim(),
				currency_id: this.currency.id,
				approval_by: this.approver.id,
				status: status,
				send_email: send_email,
				details: details
			};

			if (period_id !== 0) {
				claim['period_id'] = period_id;
			}

			return claim;
		},
		async onCloseClaims() {
			if (this.claimId === 0 && this.details.length !== 0) {
				const receipt_ids = this.details
					.map(detail => detail.receipt_id)
					.filter((receipt_id, index, ids) => receipt_id && ids.indexOf(receipt_id) === index);

				await Promise.all(receipt_ids.map(receipt_id => this._deleteReceipt(receipt_id)));
				this.details = [];
			}

			this.$emit('close');
		},
		_deleteReceipt(receipt_id) {
			const url = "/api/expenses/receipts/" + receipt_id;

			return axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason} = val.data;

					if (status == "OK") {
						return true;
					}

					this.error_msg = reason;
					return false;
				})
				.catch((e) => {
					this.error_msg = e.message;
					return false;
				});
		},
		_newReceipt(blob) {
			const url = "/api/expenses/receipts";

			return axios
				.post(url, blob, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						return data;
					}

					this.error_msg = reason;
					return null;
				})
				.catch((e) => {
					this.error_msg = e.message;
					return null;
				});
		},
		_updateReceipt(receipt_id, detail, new_receipt_employee) {
			const receipt_employee = new_receipt_employee || detail.receipt_employee || this.employee;
			const tax_mode = detail.tax_setting ? detail.tax_setting.value : detail.tax_mode;
			const params = {
				employee_id: receipt_employee.id,
				desc: detail.description,
				date: detail.date,
				currency_id: detail.currency.id,
				gross: detail.gross,
				has_tax: tax_mode === 1 || tax_mode === 4 ? 0 : 1,
				tax_mode: tax_mode,
				tax_perc: detail.tax_perc,
				tax_amount: detail.tax_amount,
				markup_perc: detail.markup,
				value: detail.value_fc
			};

			if (detail.job) {
				params['job_id'] = detail.job.id;
			}
			if (detail.phase) {
				params['phase_id'] = detail.phase.id;
			}
			if (detail.kind) {
				params['kind_id'] = detail.kind.id;
			}

			const url = "/api/expenses/receipts/" + receipt_id;

			return axios
				.put(url, params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						return true;
					}

					this.error_msg = reason;
					return false;
				})
				.catch((e) => {
					this.error_msg = e.message;
					return false;
				});
		},
		async _get_exchange_rate(currency_id, date) {
			let rate = null;
			const url = "/api/config/currency/" + currency_id + "/exchange_rates/" + date;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						rate = data.rate;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});

			return rate;
		},
		_post_gl(id) {
			this.post_loading = true;

			const url = `/api/supplier_invoice/${id}/transaction`
			axios
				.post(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.getClaim(this.claimId);

						this.notice_text = ['Your claim has been posted successfully.'];
						this.visible_notice = true;
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.post_loading = false;
				});
		},
		setPrintItem() {
			this.print_claims = [];

			const obj = {
				id: this.claimId,
				number: this.claim_number,
				desc: this.description,
				submitted_date: this.claim_submitted_date,
				value: this.attachedTotals.toPay,
				currency: this.currency.symbol,
				approval_by: this.approver ? this.approver.name : '',
				employee: this.employee ? this.employee.name : '',
				supplier: this.employee ? this.employee.name : '',
				claim_date: this.date,
				details: this.details,
				image_arr: this.image_arr
			}

			this.print_claims.push(obj);

			setTimeout(() => { 
				const printHtml = document.getElementById("print").innerHTML;
				const printFrame = document.createElement('iframe');
				printFrame.srcdoc = printHtml;
				document.body.appendChild(printFrame);

				printFrame.onload = () => {
					printFrame.contentWindow.print();
					
					const mql = printFrame.contentWindow.matchMedia('print');
					mql.onchange = (e) => {
						if (e.matches) {
							/* before print */
						} else {
							/* after print */
							document.body.removeChild(printFrame);
							this.print_loading = false;
							this.image_arr = [];
						}
					}
				}
			},20);
		},
		getImageList(image_blob_arr) {
			for (let index = 0; index < image_blob_arr.length; index++) {
				const image_blob = image_blob_arr[index];
				if (image_blob.data.type === 'application/pdf') {
					const reader = new FileReader();
					reader.readAsDataURL(image_blob.data);
					reader.onload = readerEvent =>  {
						const loadingTask = pdfjsLib.getDocument(readerEvent.target.result);
						loadingTask.promise.then(pdf => {
							const preview_url = [];
							let page_total = pdf.numPages;

							for (let index = 0; index < pdf.numPages; index++) {
								pdf.getPage(index + 1).then(page => {
									const scale = SCALE;
									const viewport = page.getViewport({scale: scale});

									const canvas = document.createElement('canvas');
									const context = canvas.getContext('2d');
									canvas.width = viewport.width;
									canvas.height = viewport.height;

									const renderContext = {
										canvasContext: context,
										viewport: viewport
									};

									const renderTask = page.render(renderContext);
									renderTask.promise.then(() => {
										canvas.toBlob(blob => {
											const preview_item_url = URL.createObjectURL(blob);
											preview_url.push(preview_item_url);
											page_total -= 1;

											if (page_total === PAGE_INIT) {
												const dimension = this.getDimension(viewport.width, viewport.height);
												const image_obj = {
													id: image_blob.id,
													width: dimension.width,
													height: dimension.height,
													image: preview_url
												};
												this.image_arr.push(image_obj);

												if (this.image_arr.length === image_blob_arr.length) {
													this.setPrintItem();
												}
											}
										});									
									});
								});
							}
						});
					};
				} else {
					const my_image = new Image();
					const preview_item_url = URL.createObjectURL(image_blob.data);
					my_image.src = preview_item_url;
					my_image.onload = () => {
						const dimension = this.getDimension(my_image.width, my_image.height);
						const image_obj = {
							id: image_blob.id,
							width: dimension.width,
							height: dimension.height,
							image: preview_item_url
						};
						this.image_arr.push(image_obj);

						if (this.image_arr.length === image_blob_arr.length) {
							this.setPrintItem();
						}
					}
				}				
			}
		},
		getDimension(width, height) {
			let image_width = 0;
			let image_height = 0;

			if (this.$vuetify.breakpoint.smAndDown) {
				/* 48 = padding-left-24px + padding-right-24px */
				if (width > height) {
					image_width = this.$vuetify.breakpoint.width - 48;
					image_height = (this.$vuetify.breakpoint.width - 48) * height / width;
				} else {
					image_height = this.$vuetify.breakpoint.width - 48;
					image_width = (this.$vuetify.breakpoint.width - 48) * width / height;
				}
			} else {
				if (width > height) {
					image_width = MAX_WIDTH;
					image_height = MAX_WIDTH * height / width;
				} else {
					image_height = MAX_WIDTH;
					image_width = MAX_WIDTH * width / height;
				}
			}

			return { width: image_width, height: image_height };
		},
	}
}
</script>
<style lang="scss" scoped>
.title-text {
	font-family: Roboto;
	font-weight: 500;
	font-size: 20px;
	line-height: 32px;
	color: #192A3E;
}

.whole-context {
	background-color: #EFF1F3;
	height: calc(100vh - 72px);
}

.inside-context {
	background-color: #FFFFFF;
	border: 1px solid rgba(25, 42, 62, 0.3);
	// height: calc(100vh - 74px - 40px);
}

.button-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  border-radius: 4px;
}

.field-title-text {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #37495F;
}

.attached-title {
	font-family: Roboto;
	font-weight: 500;
	font-size: 20px;
	line-height: 32px;
	color: #192A3E;
}

.attached-actions {
	min-height: 40px;
}

.attached-action-buttons {
	display: flex;
	align-items: center;
	margin-left: 16px;
}

@media (max-width: 600px) {
	.attached-title {
		width: 100%;
	}

	.attached-action-buttons {
		width: 100%;
		margin-top: 8px;
		margin-left: 0;
	}
}

.attached-table {
	border: 1px solid rgba(25, 42, 62, 0.25);
}

.attached-table table {
	table-layout: fixed;
}

.attached-table th {
	height: 60px;
	background-color: #FAFAFA;
}

.attached-table-text {
	font-family: Roboto;
	font-weight: 500;
	font-size: 12px;
	color: #192A3E;
}

.attached-table td {
	height: 48px;
	font-family: Roboto;
	font-size: 14px;
	color: #192A3E;
}

.attached-expense-row td {
	text-align: center;
	vertical-align: middle;
}

.split-expense-row,
.split-expense-row:hover {
	background-color: #FBF7F0 !important;
}

.amount-cell-value {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	height: 32px;
	margin: 0 4px;
}

.amount-cell-value.zero-amount-cell {
	border: 2px solid #F45252;
	border-radius: 4px;
}

.select-col {
	width: 50px;
	text-align: center;
	vertical-align: middle;
}

.attached-total-row {
	background-color: rgb(208, 208, 213);
	
}

.attached-total-row td {
	font-family: Roboto;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
}

::v-deep {
	.currency-required.v-text-field--outlined fieldset {
		border-width: 2px !important;
		border-color: var(--currency-border-color) !important;
	}

	.v-input input::placeholder {
		color: red;
	}

	.attached-table .attached-checkbox .v-input__slot {
		justify-content: center;
		margin-bottom: 0;
	}

	.attached-table .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr.attached-total-row:hover,
	.attached-table .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr.attached-total-row:hover>td {
		background-color: #D0D0D4 !important;
	}

	.attached-table .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr.add-expense-row:hover,
	.attached-table .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr.add-expense-row:hover>td {
		background-color: #FFFFFF !important;
	}
}
</style>
